export * from './app-header.component';



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/components/app-header/index.ts